import { notification } from 'antd';

notification.config({
  placement: 'topRight',
  bottom: 50,
  duration: 4,
});

export function successMsg(msg, description) {
  notification.success({
    message: msg,
    description,
  });
}

export function infoMsg(msg, description) {
  notification.info({
    message: msg,
    description,
  });
}

export function warningMsg(msg, description) {
  notification.warning({
    message: msg,
    description,
  });
}

export function errorMsg(msg, description) {
  notification.error({
    message: msg,
    description,
  });
}
